{
    "technical_error_message": "Det har skjedd en teknisk feil. Prøv igjen senere."
}
